import { render, staticRenderFns } from "./upgradeClose.vue?vue&type=template&id=0f041100&scoped=true&"
import script from "./upgradeClose.vue?vue&type=script&lang=js&"
export * from "./upgradeClose.vue?vue&type=script&lang=js&"
import style0 from "./upgradeClose.vue?vue&type=style&index=0&id=0f041100&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f041100",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f041100')) {
      api.createRecord('0f041100', component.options)
    } else {
      api.reload('0f041100', component.options)
    }
    module.hot.accept("./upgradeClose.vue?vue&type=template&id=0f041100&scoped=true&", function () {
      api.rerender('0f041100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/upgradeClose.vue"
export default component.exports